// Authentication service for handling user authentication operations
import Cookies from 'js-cookie';
import mixpanel from 'mixpanel-browser';
import { BillingSource, UserTeamSummary } from '../../types';

export interface AuthConfig {
  userInfo?: {
    name: string;
    email: string;
    status: string;
    credits_used: number;
    subscription_type?: string;
    // Team-aware credit fields from /auth/credit-info (see src/types.ts User).
    credits_total?: number | null;
    billing_source?: BillingSource;
    team?: UserTeamSummary | null;
    raw_status?: string;
    has_team?: boolean;
  } | null;
}

export interface AuthCallbacks {
  navigate: (path: string) => void;
}

// Handle complete user logout process including analytics tracking
export function handleLogout(
  config: AuthConfig,
  callbacks: AuthCallbacks
): void {
  // Track logout event before clearing data
  mixpanel.track('User Logged Out', {
    user_email: config.userInfo?.email,
    user_status: config.userInfo?.status,
    session_duration_ms: Date.now() - (parseInt(localStorage.getItem('session_start_time') || Date.now().toString()))
  });
  
  // Clear all localStorage items
  localStorage.clear();
  
  // Remove the authentication cookie with all possible variations to ensure it's fully cleared
  Cookies.remove('powerai_auth', { 
    domain: '.powerai.id',
    secure: true,
    sameSite: 'lax'
  });
  
  // Also try removing without domain specification
  Cookies.remove('powerai_auth');
  
  // Also try removing from root domain
  Cookies.remove('powerai_auth', { 
    domain: 'powerai.id'
  });
  
  // Reset Mixpanel user
  mixpanel.reset();
  
  // Navigate to login page
  callbacks.navigate('/login');
}